<div class="chart-container">
  @if (!pieChartData?.datasets?.[0]?.data?.length) {
    <div class="flex justify-center items-center">
      @if (isLoading) {
        <div class="loading-spinner">
          <mat-spinner [diameter]="50"></mat-spinner>
        </div>
      } @else {
        <svg width="400" height="250px">
          <circle
            cx="200"
            cy="125"
            r="115"
            class="fill-black/10 stroke-gray-300 stroke-2 drop-shadow"
          ></circle>

          <text
            x="200"
            y="125"
            font-size="15"
            text-anchor="middle"
            fill="#ffff"
          >
            No tickets for given time range
          </text>
        </svg>
      }
    </div>
  } @else {
    <div class="flex justify-center items-center">
      <canvas
        class="drop-shadow"
        baseChart
        [data]="pieChartData"
        [options]="pieChartOptions"
        [labels]="pieChartData.labels"
        [type]="pieChartType"
      ></canvas>
    </div>
  }
</div>
